module.exports = __webpack_public_path__ + "static/img/decoright.d26206b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/decoright.png
// module id = 3rck
// module chunks = 46